import { render, staticRenderFns } from "./partner-card.vue?vue&type=template&id=7b4095f9&"
import script from "./partner-card.ts?vue&type=script&lang=ts&"
export * from "./partner-card.ts?vue&type=script&lang=ts&"
import style0 from "./partner-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports